import type { ReactNode } from "react"
import { ApolloProvider as BaseApolloProvider } from "@apollo/client"
import client from "@/v2-backoffice-client/apollo/apollo.client"

type ApolloProviderProps = {
  children: ReactNode
}

function ApolloProvider(props: ApolloProviderProps) {
  const { children } = props
  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>
}

export default ApolloProvider
